import React, { createContext, useContext, useEffect, useState } from "react";
import RareBoxLogo from "../Logos/RareBoxLogo";
import { GlobalState } from "./GlobalContext";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import { Outlet } from "react-router-dom";

const AudienceDashboardContext = createContext();
// api url

const AudienceDashboardProvider = ({ children }) => {
	const [loading, setLoading] = useState(false);
	const [moengDrawerListItems, setMoengDrawerListItems] = useState();
	const [fbDrawerListItems, setFbDrawerListItems] = useState();
	const [clevertapDrawerListItems, setClevertapDrawerListItems] = useState();
	// const { rootPath, setRootPath, setLoginUser } = GlobalState();

	return (
		<AudienceDashboardContext.Provider
			value={{
				moengDrawerListItems,
				setMoengDrawerListItems,
				fbDrawerListItems,
				setFbDrawerListItems,
				clevertapDrawerListItems,
				setClevertapDrawerListItems,
			}}>
			{loading ? (
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			) : (
				<Outlet />
			)}
		</AudienceDashboardContext.Provider>
	);
};

export const AudienceDashboardState = () => {
	return useContext(AudienceDashboardContext);
};

export default AudienceDashboardProvider;
